import React, { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import BannerImage from "../components/img/ent-banner.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import "../styles/pages.css";
import { FaChevronRight, FaCircleArrowRight } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

function EntAudiology() {
  const [activeSection, setActiveSection] = useState("overview");
  const [isFixed, setIsFixed] = useState(false);
  const sectionsRef = {
    overview: useRef(null),
    treatment: useRef(null),
    facilities: useRef(null),
    doctors: useRef(null),
  };
  const sidebarRef = useRef(null);
  const contentRef = useRef(null);
  const footerRef = useRef(null);

  const handleScroll = () => {
    const sections = ["overview", "treatment", "facilities", "doctors"];
    let currentSection = "";
    let setFix = false;
    for (let section of sections) {
      const ref = sectionsRef[section].current;
      const { top, bottom } = ref.getBoundingClientRect();
      const isInView =
        top <= window.innerHeight / 2 && bottom >= window.innerHeight / 2;
      if (top < 85) {
        setFix = true;
      } else {
        setFix = false;
      }
      if (isInView) {
        console.log("top", top, "bottom", bottom, "win", window.innerHeight);
        currentSection = section;
      }
    }
    setIsFixed(setFix);
    setActiveSection(currentSection);
  };

  const scrollToSection = (section) => {
    const sectionElement = sectionsRef[section].current;
    if (sectionElement) {
      const offsetTop = sectionElement.getBoundingClientRect().top + window.scrollY;
      const headerOffset = 100; // Adjust this value to match the height of your fixed header or sidebar
      window.scrollTo({
        top: offsetTop - headerOffset,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    handleScroll(); // Trigger once on load
    window.addEventListener("scroll", handleScroll);
  }, []);

  const [doctors, setDoctors] = useState([]);
  const [error, setError] = useState(null);
  const filteredDoctors = doctors.filter(doctor => doctor.department_name === "ENT & Audiology");

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await axios.get(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_doctors.php`);
        setDoctors(response.data);
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    };
    fetchDoctors();
  }, []);

  const navigate = useNavigate();
  
  const handleDoctorClick = (doctor) => {
    navigate(`/doctor/${doctor.id}`, { state: { doctor } })
  };

  return (
    <div>

        {/* Navbar starts here  */}

            <Navbar />

        {/* Navbar ends here */}

        <section className="page-section">
            <div className="section-content">
                <p className='page-heading'>ENT & Audiology</p>
                
                <div class="d-none d-md-block"> {/*Visible on desktop, hidden on mobile */}
                    <p className="page-subtitle">
                        Advanced ENT and Audiology Services for Optimal Ear, Nose, 
                        <br/>
                        and Throat Health.
                    </p>
                </div>

                <div class="d-md-none mb-2"> {/* Visible on mobile, hidden on desktop */}
                    <p className="page-subtitle">
                        Advanced ENT and Audiology Services for Optimal Ear, Nose, and Throat Health.
                    </p>
                </div>

                <div className="page-box">
                    <div className="box-content">
                        <p>Caritas Matha Hospital's ENT & Audiology department offers specialized care for ear, nose, throat conditions, and hearing disorders. Our expert team provides advanced diagnostics, treatments including surgery, and hearing aid fittings, focusing on improving auditory health and overall well-being.</p>
                    </div>
                    <div className="box-image">
                        <img src={BannerImage} alt="ENT & Audiology Banner"/>
                    </div>
                </div>
            </div>
        </section>
        <section className="dept-section">
            <div
            ref={sidebarRef}
            className={`sidebar-title ${!isFixed ? "fixed" : ""}`}
            >
            {["overview", "treatment", "facilities", "doctors"].map((section) => (
                <p
                key={section}
                className={`title ${activeSection === section ? "active" : ""}`}
                onClick={() => scrollToSection(section)}
                >
                {section.charAt(0).toUpperCase() + section.slice(1)}
                {activeSection === section && (
                    <FontAwesomeIcon
                    icon={faChevronRight}
                    className="chevron-icon"
                    />
                )}
                </p>
            ))}
            </div>
            <div ref={contentRef} className="contents">
                <div ref={sectionsRef.overview} className="overview-content">
                    <p className="content-heading">Overview</p>
                    {/* Overview content here */}
                    <p>The Department of ENT & Audiology at Caritas Matha Hospital offers comprehensive care for disorders related to the ear, nose, and throat. Known for its expertise in Central Travancore, the department provides advanced treatments and surgical interventions for a wide range of ENT conditions. Our team of ENT specialists and audiologists is committed to delivering personalized care with a focus on improving quality of life and restoring sensory functions.</p>

                    <p>We emphasize a patient-centered approach, where every treatment plan is tailored to meet the unique needs of each individual. Whether addressing chronic sinus issues, conducting intricate ear surgeries, or managing complex head and neck tumours, our specialists utilize the latest medical advancements and techniques to ensure the best possible outcomes. We strive to create a supportive environment where patients feel informed, empowered, and confident in their care journey.</p>

                    <p>Caritas Matha Hospital is equipped with state-of-the-art facilities to support our ENT services. Our specialized operation theaters are designed for precision surgeries, equipped with advanced technology such as endoscopic instruments and imaging systems for accurate diagnosis and treatment. We maintain high standards of safety and hygiene, ensuring that each procedure is conducted under optimal conditions to promote successful recovery and improved health outcomes.</p>

                </div>
                <div ref={sectionsRef.treatment} className="treatment-content">
                    <p className="content-heading">Treatment</p>
                    {/* Treatment content here */}
                    
                    
                    <p>Our department offers a wide array of services, including : </p>
                    <ul>

                        <li>
                          <span className="subtitle">General ENT Surgeries : </span>Procedures such as septoplasty, SMR (submucous resection), tonsillectomy, adenoidectomy, pre-auricular cyst excision, Caldwell-luc procedure, dental cyst enucleation, and cosmetic septorhinoplasty.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Coblation Surgeries : </span>Endoscopic coblation adenoidectomy(painless and bloodless surgery), Coblation Tonsillec</li>
                        <br/>

                        <li>
                          <span className="subtitle">Surgeries for snoring and sleep apnea : </span>(Coblation) - Uvulopalatopharyngoplasty, or UPPP, Endoscopic skull base surgery, CSF Rhinorrhea, DCR, Thyroid surgeries, Salivary gland Surgery, Rhinoplasty, Tracheostomy</li>
                        <br/>

                        <li>
                          <span className="subtitle">ENT Trauma Surgery : </span>Nasal septum bone fracture, Pinna injury, Nose</li>
                        <br/>

                        <li>
                          <span className="subtitle">Micro Ear Surgeries : </span>Advanced procedures like tympanoplasty (eardrum repair), mastoidectomy, and modified radical mastoidectomy for ear conditions.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Endoscopic Nasal Surgery (FESS) : </span>Treatment for chronic sinusitis, nasal polyps, dacryocystorhinostomy (DCR), and benign tumors of the nerve and nasopharynx.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Micro-laryngeal Surgeries : </span>Including vocal cord polyp and vocal cord nodule removal, addressing both benign and malignant conditions.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Head & Neck Pathologies : </span>Management of benign and malignant tumors, abscess drainage, and other pathologies affecting the head and neck region.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Therapeutic & Diagnostic Procedures : </span>For larynx and esophagus, including foreign body removal and diagnostic endoscopic examinations.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Audiology Services : </span>Comprehensive assessment and management of hearing loss, including audiometry, impedance audiometry, OAE (otoacoustic emissions), BERA (brainstem evoked response audiometry), and VEMP (vestibular evoked myogenic potentials).</li>
                        <br/>

                        <li>
                          <span className="subtitle">Speech-Language Pathology : </span>Evaluation and therapy for speech and language disorders, including delayed speech and language development, dysarthria, dysphagia (swallowing disorders), aphasia, stuttering, and more.</li>
                        <br/>

                    </ul>

                </div>
                <div ref={sectionsRef.facilities} className="facilities-content">
                    <p className="content-heading">Facilities</p>
                    {/* Facilities content here */}

                    <br/>
                    <ul>
                        <li>
                          <span className="subtitle">Outpatient Consultations : </span>Available on all working days, ensuring accessible care forroutine check-ups and consultations.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Nasal Endoscopy & Video-Laryngoscopy : </span>Outpatient procedures performed todiagnose and treat nasal and laryngeal conditions.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Hearing Tests : </span>Regular tests for hearing loss and dizziness to facilitate early diagnosisand intervention.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Speech Therapy Department : </span>Specialized programs tailored for various conditionsaffecting speech and language development.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Audiology Services : </span>Including hearing aid trials, fittings, and rehabilitation forconditions like tinnitus, hyperacusis, auditory processing disorders, and cochlear implantmanagement.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Multidisciplinary Approach : </span>Collaborative care with other specialties to addresscomplex cases and provide integrated treatment plans.</li>
                        <br/>


                    </ul>

        
                </div>

                <div ref={sectionsRef.doctors} className="doctors">
                    <p className="content-heading">Doctors</p>

                    {error && <p>{error}</p>}
                    {filteredDoctors.length > 0 ? (
                        <div className='doctorbox-container'>
                            {filteredDoctors.map(doctor => (
                              <div key={doctor.id} className="doctorbox">
                                <div className="doctor-box">
                                    <img src={doctor.image_url} className='doctor-img' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                                    <div className='doctor-details'>
                                        <h4 onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}>{doctor['name']}</h4>
                                        <p>{doctor['designation']}</p>
                                        <p>{ doctor.available_time }</p>
                                        <br/>
                                        {parseInt(doctor.appointment_enabled) === 1 && (
                                            <p>
                                                <a href="https://booking.caritasmathahospital.com/OnlineAppointmentBooking/OnlineAppointmentBooking.aspx" target="_blank" rel="noopener noreferrer" >
                                                    Book An Appointment <FaChevronRight />
                                                </a>
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className='arrow-section'>
                                    <FaCircleArrowRight className='right-circle-arrow' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                                </div>
                              </div>
                            ))}
                        </div>
                    ) : (
                        !error && <p>No doctors available in this department.</p>
                    )}
                </div>
            </div>
        </section>

        {/* Footer Starts here */}

            <Footer ref={footerRef} />

        {/* Footer ends here */}
    </div>
  );
}

export default EntAudiology;